module.exports = __webpack_public_path__ + "img/Expo.38cf3e50.png";